import { render, staticRenderFns } from "./CurrencyMenu.vue?vue&type=template&id=6241a640&"
import script from "./CurrencyMenu.vue?vue&type=script&lang=js&"
export * from "./CurrencyMenu.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports